/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { GenderEnum } from '../../../enums/genderEnum';
import { DriverModel } from '../../../models/driver';
import axios from '../../../lib/axios';
import {
  UPDATE_RIDER_PROFILE,
  USER_RIDER_BAN,
  USER_RIDER_CREATE,
  USER_RIDER_UPDATE,
} from '../../../lib/endpoints/rider';
import moment from 'moment';
import { generateImageFileNameWithRandomName } from '../../../utils/generateImageFileName';
import { useTranslation } from 'react-i18next';
import { DriverEnum } from '../../../enums/driverEnum';
import { IMAGE_RIDER_PROFILE } from '../../../lib/endpoints/profileImage';

interface Props {
  selectedProfileData: DriverModel;
  onClose: VoidFunction;
  onFetchData: Function;
  selected: Function;
}

export const useFormDriverController = ({
  selectedProfileData,
  onClose,
  onFetchData,
  selected,
}: Props) => {
  const [banUser, setBanUser] = useState<boolean>(false);
  const [imageToShow, setImageToShow] = useState<any>(null!);
  const [imageFile, setImageFile] = useState<any>(null!);
  const [selectedGender, setSelectedGender] = useState<GenderEnum>(GenderEnum.OTHER);
  const [selectedDriverType, setSelectedDriverType] = useState<DriverEnum>(DriverEnum.FULLTIME);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [loadingConfirmForm, setLoadingConfirmForm] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const fullName = useRef<HTMLInputElement>(null!);
  const phoneNumber = useRef<HTMLInputElement>(null!);
  const secondPhone = useRef<HTMLInputElement>(null!);
  const area = useRef<HTMLInputElement>(null!);
  const dateOfBirth = useRef<HTMLInputElement>(null!);
  const username = useRef<HTMLInputElement>(null!);
  const password = useRef<HTMLInputElement>(null!);
  const confirmPassword = useRef<HTMLInputElement>(null!);
  const role = useRef<HTMLInputElement>(null!);
  const order = useRef<HTMLInputElement>(null!);
  const money = useRef<HTMLInputElement>(null!);

  const { t } = useTranslation('global');

  const handleBanUser = (newValue: boolean) => {
    setBanUser(newValue);
  };

  const handleSelectedImage = (e: any) => {
    const file = e.target.files[0];
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageToShow(file);
  };

  const handleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleShowConfirmPassword = (e: any) => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const handleSelectedGender = (e: any) => {
    setSelectedGender(e.target.value);
  };

  const handleSelectedDriverType = (e: any) => {
    setSelectedDriverType(e.target.value);
  };

  const handleOpenAddRiderForm = (e: any) => {
    e.preventDefault();
    if (handleValidate()) {
      setOpenConfirm(true);
    }
  };

  const handleCloseAddRiderForm = () => {
    setOpenConfirm(false);
  };

  const handleValidate = () => {
    if (!selectedProfileData && !imageFile) {
      setErrorMessage('Please select an image.');
      return false;
    }
    if (!/^\d+$/.test(phoneNumber.current?.value)) {
      setErrorMessage('Phone number must contain only digits.');
      return false;
    }
    if (!/^\d+$/.test(secondPhone.current?.value)) {
      setErrorMessage('Phone number must contain only digits.');
      return false;
    }
    if (!dateOfBirth.current?.value) {
      setErrorMessage('Please enter your date of birth.');
      return false;
    }
    if (phoneNumber.current?.value.length < 8) {
      setErrorMessage('Phone number must be at least greater than or equal to 8 digits');
      return false;
    }
    if (secondPhone.current?.value.length < 8) {
      setErrorMessage('Phone number must be at least greater than or equal to 8 digits');
      return false;
    }
    if (password.current?.value !== confirmPassword.current?.value) {
      setErrorMessage('Password and Confirm Password do not match.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleReset = () => {
    selected(null);
    setImageToShow(null);
    setImageFile(null);

    if (fullName.current) fullName.current.value = '';
    if (phoneNumber.current) phoneNumber.current.value = '';
    if (secondPhone.current) secondPhone.current.value = '';
    if (area.current) area.current.value = '';
    if (dateOfBirth.current) dateOfBirth.current.value = '';
  };

  const handleSubmit = () => {
    if (selectedProfileData?.rider?.id) {
      handleEditRider();
      handleEditRiderProfile();
      handleBanRider();
    } else {
      handleAddRider();
    }
  };

  const handleDateChange = () => {
    const inputDate = selectedProfileData?.profile?.dateOfBirth;
    const dateObject = moment(inputDate, 'DD/MM/YYYY');
    const formattedDate = dateObject.format('YYYY-MM-DD');

    return formattedDate;
  };

  const handleAddRider = async () => {
    try {
      setLoadingConfirmForm(true);
      const riderUserBody: any = {
        username: username.current.value,
        password: password.current.value,
        type: selectedDriverType,
        limitOption: {
          orders: parseInt(order.current?.value),
          money: parseInt(money.current?.value),
        },
      };
      const res = await axios.post(
        `${USER_RIDER_CREATE}?fullName=${fullName.current.value}&area=${
          area.current.value
        }&dateOfBirth=${moment(new Date(dateOfBirth.current.value)).format('DD/MM/YYYY')}`,
        riderUserBody
      );
      const getProfileId = res.data?.profile?.id;

      const formData = new FormData();
      formData.append('fullName', fullName.current.value);
      formData.append('phoneNumber', phoneNumber.current.value);
      formData.append('secondPhone', secondPhone.current.value);
      formData.append('area', area.current.value);
      formData.append(
        'dateOfBirth',
        moment(new Date(dateOfBirth.current.value)).format('DD/MM/YYYY')
      );
      formData.append('gender', selectedGender);
      formData.append('image', generateImageFileNameWithRandomName(imageFile));

      await axios.patch(UPDATE_RIDER_PROFILE + getProfileId, formData);
      onFetchData();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
    }
  };

  const handleEditRiderProfile = async () => {
    try {
      setLoadingConfirmForm(true);

      const formData = new FormData();
      formData.append('fullName', fullName.current.value);
      formData.append('phoneNumber', phoneNumber.current.value);
      formData.append('secondPhone', secondPhone.current.value);
      formData.append('area', area.current.value);
      formData.append(
        'dateOfBirth',
        moment(new Date(dateOfBirth.current.value)).format('DD/MM/YYYY')
      );
      if (selectedGender) {
        formData.append('gender', selectedGender);
      }
      if (imageFile) {
        formData.append('image', generateImageFileNameWithRandomName(imageFile));
      }

      await axios.patch(UPDATE_RIDER_PROFILE + selectedProfileData?.profile?.id, formData);
      onFetchData();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
    }
  };

  const handleEditRider = async () => {
    try {
      const riderUserBody: any = {
        type: selectedDriverType,
        limitOption: {
          orders: parseInt(order.current?.value),
          money: parseInt(money.current?.value),
        },
      };
      await axios.patch(USER_RIDER_UPDATE + selectedProfileData?.rider?.id, riderUserBody);
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
    }
  };

  const handleBanRider = async () => {
    try {
      setLoadingConfirmForm(true);
      await axios.post(USER_RIDER_BAN, {
        id: selectedProfileData?.rider?.id,
        temporaryBan: banUser,
      });
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
    }
  };

  useEffect(() => {
    if (selectedProfileData) {
      fullName.current.value = selectedProfileData?.profile?.fullName;
      phoneNumber.current.value = selectedProfileData?.profile?.phoneNumber;
      secondPhone.current.value = selectedProfileData?.profile?.secondPhone;
      area.current.value = selectedProfileData?.profile?.area;
      dateOfBirth.current.value = handleDateChange();
      setSelectedGender(selectedProfileData.profile?.gender as GenderEnum);
      setSelectedDriverType(selectedProfileData?.rider.type as DriverEnum);
      setBanUser(selectedProfileData?.rider?.temporaryBan);
      setImageToShow(IMAGE_RIDER_PROFILE + selectedProfileData?.profile?.image?.url);
      username.current.value = selectedProfileData?.rider.username;
      order.current.value = selectedProfileData?.rider.limitOption?.orders?.toString();
      money.current.value = selectedProfileData?.rider.limitOption?.money?.toString();
    }
  }, [selectedProfileData]);

  return {
    banUser,
    handleBanUser,
    imageToShow,
    handleSelectedImage,
    selectedGender,
    handleSelectedGender,
    handleOpenAddRiderForm,
    handleSubmit,
    loadingConfirmForm,
    errorMessage,
    openConfirm,
    handleSelectedDriverType,
    selectedDriverType,
    fullName,
    phoneNumber,
    secondPhone,
    area,
    dateOfBirth,
    username,
    password,
    role,
    order,
    money,
    handleCloseAddRiderForm,
    handleReset,
    confirmPassword,
    showPassword,
    showConfirmPassword,
    handleShowPassword,
    handleShowConfirmPassword,
  };
};
